import { createContext } from "react";

const ThemeContext = createContext(["black", () => {}]);

export default ThemeContext;
